<main class="em-l-container main-content">
  <app-subscription-form></app-subscription-form>
</main>
